import React, { useState, useContext } from "react";
import { Container, Spinner, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import "../../../assets/css/Drivers/DriverSetting/DriverSecurity.css";
import DriverSettingsMasterLayout from "../../../layouts/Drivers/DriverSettingsMasterLayout";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const DriverSecurity = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [form, setForm] = useState({
    previousPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    previousPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const toggleShow = (field) => {
    setShowPassword({ ...showPassword, [field]: !showPassword[field] });
  };

  const handleSubmit = () => {
    if (!form.previousPassword || !form.newPassword || !form.confirmPassword) {
      alert("Please fill all fields.");
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      alert("New password and confirm password do not match.");
      return;
    }
    if (form.newPassword.length < 8) {
      alert("Password must be at least 8 characters.");
      return;
    }

    setLoading(true);

    axios
      .post(
        `${baseUrl}/driver/auth/changePassword`,
        {
          previous_password: form.previousPassword,
          new_password: form.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      )
      .then((response) => {
        setLoading(false);

        if (response.data.success === true) {
          setForm({
            previousPassword: "",
            newPassword: "",
            confirmPassword: "",
          });

          setShowSuccessModal(true);

          setTimeout(() => {
            setShowSuccessModal(false);
            navigate("/driver-dashboard");
          }, 2200);
        } else {
          alert(response.data.message || "Wrong password");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  const fields = [
    {
      key: "previousPassword",
      label: "Previous Password",
      placeholder: "Enter previous password",
    },
    {
      key: "newPassword",
      label: "New Password",
      placeholder: "Enter new password",
    },
    {
      key: "confirmPassword",
      label: "Confirm New Password",
      placeholder: "Re-enter new password",
    },
  ];

  return (
    <DriverSettingsMasterLayout screenName={"DriverSecurity"} centered={true}>
      <div className="DriverSecurity-wrapper">
        {/* Body */}
        <Container fluid className="DriverSecurity-body">
          {/* Top Icon Section */}
          <div className="DriverSecurity-top-section">
            <div className="DriverSecurity-icon-circle">
              <FaLock size={26} color="#ffffff" />
            </div>
            <h2 className="DriverSecurity-title">Change Password</h2>
            <p className="DriverSecurity-subtitle">
              Please enter your current password and create a new secure
              password
            </p>
          </div>

          {/* Form */}
          <div className="DriverSecurity-form">
            {fields.map((field) => (
              <div key={field.key}>
                <label className="DriverSecurity-field-label">
                  {field.label}
                </label>
                <div className="DriverSecurity-input-wrapper">
                  <span className="DriverSecurity-input-icon">
                    <FaLock size={14} />
                  </span>
                  <input
                    className="DriverSecurity-input"
                    type={showPassword[field.key] ? "text" : "password"}
                    name={field.key}
                    value={form[field.key]}
                    onChange={handleChange}
                    placeholder={field.placeholder}
                  />
                  <button
                    className="DriverSecurity-eye-btn"
                    onClick={() => toggleShow(field.key)}
                    type="button"
                  >
                    {showPassword[field.key] ? (
                      <FaEyeSlash size={16} />
                    ) : (
                      <FaEye size={16} />
                    )}
                  </button>
                </div>
              </div>
            ))}

            {/* Submit Button */}
            <button
              className="DriverSecurity-submit-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="ms-2">Loading...</span>
                </>
              ) : (
                "Update Password"
              )}
            </button>
          </div>

          {/* Success Celebration Modal */}
          <Modal show={showSuccessModal} centered backdrop="static">
            <Modal.Body className="text-center p-5">
              <div style={{ fontSize: "48px" }}>🎉</div>
              <h3>Congratulations!</h3>
              <p>
                Your password has been updated successfully. <br />
              </p>
              <div className="spinner-border mt-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    </DriverSettingsMasterLayout>
  );
};

export default DriverSecurity;
